import PROFILE from './info/profile'
import LINE_SPECIAL from './info/lineSpecial'

const COLLECTION_ICONS_DIR = '/static/img/recommend/lp/common/collection_icons/'
export const colorScheme = {
  keyColor: '#142254',
  second: '#6cd7d0',
  gradStart: '#537fe4',
  gradEnd: '#5beae8',
  baseBg: '#142254', // ヘッダ用のBGとして使用(指定がない場合はgradStart,gradEndを使用し標準パラメータでグラデーションを描画)
  infoBg: '#f1f8ff',
  messBg: '#F3FEFF',
  profileKeyColor: '#6cd7d0',
}

const pathCommon = '/static/img/recommend/lp/common/'
const pathCounselor = '/static/img/recommend/lp/kurenotori/'
const deco = `${pathCounselor}deco.png`
const kira = `${pathCounselor}kira.png`
const counselor = `${pathCounselor}counselor.png`

const SUBSC_MENU_NUM = 70 //サブスクメニュー数

const hero = {
  //pc: `${pathCounselor}top_sp_20221003.webp`,
  //sp: `${pathCounselor}top_sp_20221003.webp`,
  fallback_pc: `${pathCounselor}top_sp_20230313.png`,
  fallback_sp: `${pathCounselor}top_sp_20230313.png`,
  alt: '大阪で８万人鑑定リピート率No.1 帝王 暮れの酉',
}

const about = {
  // deco: deco,
  img: `${pathCounselor}about.webp`,
  headline: '暮れの酉とは',
  text: '19歳から占い一筋で勉強を続け、鑑定の経験を18年間積むことで唯一無二の実力を身に付けた。<br>「占いを極めたい」という思いが強く、中国古典まで紐解いて得た豊富な知識と技術が魅力。その知識を活かし、占いアカデミーの講師も務める。<br>相手の話を聞き、寄り添う彼の言葉の力に惚れこみ、リピーターになる人が後を絶たない。',
}

const fortune = {
  deco: deco,
  headline: '鳳凰数術',
  text: '「鳳凰タイプ」で、あなたの性格と、恋愛や仕事で活きる強みが分かります。',
  kira: kira,
  you: {
    headline: '名前と誕生日からわかる<br>あなたのこと',
    text: '鳳凰数を見れば、あなたの本質も、気になるあの人の本当の姿も見えます。',
    comment: '黒鉛とダイヤモンドはどちらも炭素ですが、見た目も働きも全く違います。持って生まれた運命とはそのようなもの。<b>どう組み立て使うかで人生は大きく変わる</b>のです。',
    counselorImage: counselor,
    avatar: `${pathCommon}avatar.png`,
    sample: [
      {
        icon: `${pathCounselor}img_kekka1.png`,
        text: '正義感が強く、恥ずかしくない自分でありたいという想い',
      },
      {
        icon: `${pathCounselor}img_kekka2.png`,
        text: '実は、人を癒やす能力が高く、人に何かを教えること向いてる',
      },
    ],
    advice: '自分の運命を組み立てて、<br>幸せを掴みに行きましょう。',
  },
  method: {
    headline: '暮れの酉流奥義で<br>あなたの幸せの在り処を<br>教えます',
    text: '四柱推命や梅花心易など、さまざまな占いを身に付けた、いわば「占いのエキスパート」暮れの酉。<br>あなたの幸せの在り処もはっきりと示してみせます。',
    counselorImage: counselor,
    avatar: `${pathCommon}avatar.png`,
    sample: [
      {
        icon: `${pathCounselor}img_kekka1.png`,
        text: '恥ずかしくない自分でありたい',
      },
      {
        icon: `${pathCounselor}img_kekka2.png`,
        text: '人の気持ちを汲み取れる癒しの才能',
      },
    ],
    advice: '今の運気の流れ<br>望みが叶う可能性<br>近々訪れる運命の吉日',
  },
  free: {
    text: '自分のタイプが気になった方は、こちらから診断できますよ',
    img: `${pathCounselor}counselor2.png`,
  }
}

const review = {
  // deco: deco,
}

const menu = {
  title: '暮れの酉の占いを<br>見てみる',
  deco: deco,
}

const uTV = {
  // deco: deco,
  counselorImage: `${pathCounselor}counselor3.png`,
  lead: 'あなたがもっと<br>幸せになるために',
  resultBottomCap: `${PROFILE.name}の占いが<br>月額528円（税込）で<br>${SUBSC_MENU_NUM}メニュー占い放題！`
}

export const reviews = [
  { icon: `${pathCommon}icon_review1.png`, review: 'ちょうど今の状況、心情にドンピシャな結果でビックリしました。アドバイスを胸に頑張っていこうと思えました！' },
  { icon: `${pathCommon}icon_review2.png`, review: '占いが当たるだけでなく、どうしてそのような答えに至ったのか、暮れの酉さんが根拠をしっかり伝えて下さるので、スッと胸に入って来ました。' },
  { icon: `${pathCommon}icon_review3.png`, review: '相手の事を思って親身になって占ってくれてるのがすごく分かるし、ポジティブな考えにさせてくれる！' },
]

const title = {
  subTitle: '全81種類の鳳凰タイプで自分がわかる',
  title: '暮れの酉の鳳凰数術',
}

const fortuneResult = {
  lead: 'あなたの鳳凰タイプは',
}

const snsShare = {
  lead: '鳳凰タイプをシェアする',
}

const leadMenu = {
  deco: deco,
  counselorImage: `${pathCounselor}counselor4.png`,
  comment: '<b>運命は変えられる。</b><br>何万人も鑑定する中で僕はそう確信しました。<br><br>春はもうすぐそこ。<br><b>光の差す方へ導きましょう。</b>',
  sample1: `${pathCounselor}sample1.png`,
  sample2: `${pathCounselor}sample2.png`,
  // lead: `${pathCounselor}leadMenu_text.png`,
  lead: 'あなたのこと、<br>大切な人とのことを<br>詳しく見るなら',
}

const aboutType = {
  // deco: deco,
  counselorImage: `${pathCounselor}counselor3.png`,
  title: 'あなたが毎日を<br>ちょっと楽しく過ごすために意識してほしいこと',
}

const leadSubsc = {
  deco: deco,
}

const advice = {
  // deco: deco,
  counselorImage: `${pathCounselor}counselor5.png`,
}

const title2 = {
  // deco: deco,
  subTitle: '＼あなたの周りの人は何タイプ？／',
  title: '暮れの酉の鳳凰数術で<br>占ってみよう',
}

const menuDetails = {
  colors: {
    headBg: colorScheme.baseBg,
    headColor: 'white',
    baseBg: '#fffbe3',
    baseColor: colorScheme.baseBg,
    resultBg: 'white',
  },
  contents: [
    { icon: `${COLLECTION_ICONS_DIR}icon_collection1.png`, description: '異性はあなたのどこに魅力を感じている？' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection2.png`, description: 'あなたの力を最大限に活かせる<br>天職とは' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection3.png`, description: '結婚相手の職業と収入、将来性' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection4.png`, description: 'あなたの財運を最大限に<br>活かした稼ぎ方' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection5.png`, description: '今後ある、一生ものの出会い' },
    { icon: `${COLLECTION_ICONS_DIR}icon_collection6.png`, description: '人生の分岐点と、そのとき<br>あなたが取るべき選択肢' },
  ],
}

const floatingBanner = {
  enable: true,
  title: '<span class="name">暮れの酉</span>の<span class="emphasis">鳳凰数術</span>で',
  freeBtnFace: '無料で占う',
  colors: {
    background: '#fffbe3',
    baseText: colorScheme.baseBg,
    emphasis: colorScheme.gradStart,
    decos: colorScheme.second,
    freeBtn: colorScheme.gradStart,
    freeBtnBg: 'white',
  }
}

const lineBanner = {
  bannerUrl: '/static/img/recommend/lp/banner/kurenotori_line_20220316.png'
}

const uTvDesc = {
  leadImg: `${pathCounselor}counselor6.png`,
  lead: '鳳凰数術は、あなたの持って生まれた個性や長所を教えます。例えばこんなことだって占えるんですよ。',
  points: [{
    img: `${pathCounselor}uTVdesc/point1.png`,
    copy: `${pathCounselor}uTVdesc/point1_copy.png`,
  },{
    img: `${pathCounselor}uTVdesc/point2.png`,
    copy: `${pathCounselor}uTVdesc/point2_copy.png`,
  },{
    img: `${pathCounselor}uTVdesc/point3.png`,
    copy: `${pathCounselor}uTVdesc/point3_copy.png`,
  },{
    img: `${pathCounselor}uTVdesc/point4.png`,
    copy: `${pathCounselor}uTVdesc/point4_copy.png`,
  },{
    img: `${pathCounselor}uTVdesc/point5.png`,
    copy: `${pathCounselor}uTVdesc/point5_copy.png`,
  },{
    // img: '__ex__',
    // copy: `${pathCounselor}uTVdesc/point6_copy.png`,
    // extend: `<img src="${pathCounselor}uTVdesc/point6_copy_pre.png"><div class="seimei"><video src="https://s3-ap-northeast-1.amazonaws.com/uranaitv-town-dev/lp/video_letter/fast/seimei.mp4" autoplay loop muted playsinline></video></div>`
    preCopy: `${pathCounselor}uTVdesc/point6_copy_pre.png`,
    img: `${pathCommon}uTV/seimeinoousama.png`,
    copy: `${pathCounselor}uTVdesc/point6_copy2.png`,
  },],
}

export const information = {
  name: PROFILE.name, // ※互換のため残すが以降についてはprofile.nameを使用すること
  mainMethod: PROFILE.mainMethod, // ※互換のため残すが以降についてはprofile.mainMethodを使用すること
  profile: PROFILE,
  lineSpecial: LINE_SPECIAL,
  hero,
  about,
  fortune,
  review,
  reviews,
  menu,
  uTV,
  title,
  fortuneResult,
  snsShare,
  leadMenu,
  aboutType,
  leadSubsc,
  advice,
  title2,
  floatingBanner,
  menuDetails,
  lineBanner,
  uTvDesc,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/kurenotori/counselorInfos.js